// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-b781a706]{background-color:#fff}.root[data-v-b781a706] .v-application--wrap{min-height:auto}.noborder[data-v-b781a706]{border:none}", ""]);
// Exports
module.exports = exports;
